var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgReleaseNote = function SvgReleaseNote(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2788_8187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 3V4.085L2.82013 5.935C2.58718 5.9776 2.3769 6.10149 2.22673 6.28461C2.07657 6.46774 1.99627 6.69821 2.00013 6.935V9.105C1.99627 9.34179 2.07657 9.57226 2.22673 9.75539C2.3769 9.93851 2.58718 10.0624 2.82013 10.105L4.00013 10.28V12C4.00013 12.2652 4.10549 12.5196 4.29303 12.7071C4.48056 12.8946 4.73492 13 5.00013 13H9.00013C9.26535 13 9.5197 12.8946 9.70724 12.7071C9.89478 12.5196 10.0001 12.2652 10.0001 12V11.37L13.0001 11.915V13H14.0001V3H13.0001ZM9.00013 12H5.00013V10.465L9.00013 11.19V12ZM3.00013 9.085V6.915L13.0001 5.1V10.9L3.00013 9.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6L13 5V11L3 10V6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2788_8187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReleaseNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/release_note.de474167.svg";
export { ForwardRef as ReactComponent };